import EnumSelect from './EnumSelect';
import LanguageDropdown from './LanguageDropdown';

export default {
  Enum: EnumSelect,
  Language: LanguageDropdown,
};
